import { BaseApi } from '@/main/baseApi';

import { HromadnaObjednavka } from './store/types';
import { MODULE_API, NAME } from './constants';


class ZakazkaNdObjednavkaProvider extends BaseApi {
	constructor() {
		super(MODULE_API, NAME);
	}

	async defaultJfnd(filter: any) {
		return this.post(`/${MODULE_API}/${NAME}/defaultForJfnd?mioPzn=${filter.MioPzn}`, filter);
	}

	async hromadnaObjednavka(input: HromadnaObjednavka[]) {
		return this.post(`/${MODULE_API}/${NAME}/HromadnaObjednavka`, input);
	}
}

export const apiProvider = new ZakazkaNdObjednavkaProvider();
